module.exports = __webpack_public_path__ + "img/Butterfly_00032.153345fe.png";